module.exports = __webpack_public_path__ + "img/comment.58e655bd.svg";